import { render } from "./CardRegistroEntrega.vue?vue&type=template&id=61ff4d4b"
import script from "./CardRegistroEntrega.vue?vue&type=script&lang=js"
export * from "./CardRegistroEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__